export default class SocialShareInfo {

  private _shareLink: string;
  private _shareTitle: string;
  private _sourceUrl: string | undefined;
  private _countryCode: string | undefined;

  constructor(shareLink: string, shareTitle: string, sourceUrl?: string, countryCode?: string) {
    this._shareLink = shareLink;
    this._shareTitle = shareTitle;
    this._sourceUrl = sourceUrl;
    this._countryCode = countryCode;
  }

  public get shareLink(): string {
    return this._shareLink;
  }
  public set shareLink(value: string) {
    this._shareLink = value;
  }
  
  public get shareTitle(): string {
    return this._shareTitle;
  }
  public set shareTitle(value: string) {
    this._shareTitle = value;
  }
  
  public get sourceUrl(): string | undefined {
    return this._sourceUrl;
  }
  public set sourceUrl(value: string | undefined) {
    this._sourceUrl = value;
  }

  public get countryCode(): string | undefined {
    return this._countryCode;
  }
  public set countryCode(value: string | undefined) {
    this._countryCode = value;
  }
}